import Tick from 'Components/common/assets/svgIcons/Tick';
import { SMART_DESIGNATIONS_POINTS } from 'Utils/Constants';
import {
  SecondaryColorTwo,
  maxWidth,
  primaryColor, primaryFont, primaryHeadingColor, retina, smMobile, wMedium,
} from 'Utils/utilsStyle';
import { Spin } from 'antd';
import HTMLReactParser from 'html-react-parser';
import React from 'react';
import styled from 'styled-components';
import SmartDesignationLoadingText from './SmartDesignationLoadingText';

const Wrapper = styled.div`
  .title {
    font-family: ${primaryFont};
    font-size: 18px;
    font-weight: ${wMedium};
    line-height: 18px;
    color: ${SecondaryColorTwo};
    letter-spacing: -0.556px;
    margin-bottom: 8px;
  }
  .text {
    font-family: ${primaryFont};
    font-size: 16px;
    font-weight: ${wMedium};
    line-height: 20px;
    color: ${primaryHeadingColor};
    margin-top: 16px;
    letter-spacing: -0.556px;
    ul {
      margin-top: 1em;
      margin-bottom: 0px;
      li {
        margin-bottom: 12px;
        &:last-child {
          margin-bottom: 0px;
        }
      }
    }
  }
  .designation-loader {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: calc(100vh - 570px);
    padding-right: 22px;
    @media all and (max-width: ${maxWidth}), ${retina} {
      padding-right: 4px;
    }
    .tick-icon-svg {
      height: 24px;
      width: 26px;
      margin-bottom: 20px;
      polygon{
        stroke-width: 40px;
        stroke: ${primaryColor};
      }
    }
    .ant-spin {
      width: 48px;
      height: 47px;
      margin-bottom: 8px;
    }
    .paragraph-loader {
      color: #5E7079;
      font-family: ${primaryFont};
      font-size: 16px;
      font-weight: ${wMedium};
      line-height: 20px;
      letter-spacing: -0.556px;
      text-align: center;
    }
    .generating-img {
      width: 148px;
      height: 134px;
      flex-shrink: 0;
      @media all and (max-width: ${smMobile}) {
        width: 128px;
        height: 114px;
      }
    }
  }
`;

type Props = {
  designationsLoading: boolean
};

const SmartDesignationLoadingScreen = function SmartDesignationLoadingScreen(props: Props) {
  const { designationsLoading } = props;
  const title = 'Build a Buyer Group consisting of key decision-makers engaged in the sales cycle.';
  return (
    <Wrapper>
      <span className="title">{title}</span>
      {SMART_DESIGNATIONS_POINTS.map(
        (point, i) => <SmartDesignationLoadingText text={point} index={i} />,
      )}
      <div className="designation-loader">
        {designationsLoading ? (
          <>
            <Spin />
            <p className="paragraph-loader">{HTMLReactParser('Please wait, while we recommend <br /> you the job titles for the Buyer Group.')}</p>
          </>
        )
          : (
            <>
              <Tick />
              <p className="paragraph-loader">Click on Next to proceed</p>
            </>
          )}
      </div>
    </Wrapper>
  );
};

export default SmartDesignationLoadingScreen;
